import { TokenIcon } from './holdings-table'

/**
 * A ticker with its logo in front (John, Oct 31 2026: logos lead every ticker in toasts and status chips).
 * Top-aligned, not middle: the box is exactly one line tall, so its text shares the baseline of the words
 * around it and the logo sits centred on the line (middle alignment pushed the ticker 1.3px below "done").
 */
export function Ticker({ symbol, imageUrl, address, size = 'size-4', className = '' }: { symbol: string; imageUrl?: string | null; address?: string | null; size?: string; className?: string }) {
  return (
    <span className={`inline-flex items-center gap-1 align-top ${className}`}>
      <TokenIcon symbol={symbol} imageUrl={imageUrl ?? undefined} address={address} size={size} />
      {symbol}
    </span>
  )
}
